export const JPG = 'jpg';
export const PNG = 'png';
export const GIF = 'gif';
export const HTML = 'html';
export const ZIP = 'zip';
export const framesPerSecond = 6;
export const imageTypes = [JPG, PNG, HTML, ZIP];
